import { CommonModule, formatPercent, Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import moment from'moment-timezone';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TiretPipe } from 'src/app/pipe/tiret.pipe';
import { EvenementSessionModel } from 'src/models/EvenementSessionModel';
import { DetailSessionModel } from 'src/models/Session/detail-session-model';
import { ContenuSessionService } from 'src/services/contenu.session.service';
import { CustomPaginatorIntlService } from 'src/services/custom-paginator-intl.service';

@Component({
    selector: 'app-contenus-evenement-session',
    templateUrl: './contenus-evenement-session.component.html',
    styleUrls: ['./contenus-evenement-session.component.scss'],
    imports: [
        TranslateModule,
        CommonModule,
        MatIconModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        FormsModule,
        TranslateModule,
        MatFormFieldModule,
        MatSelectModule,
        NgxMatSelectSearchModule,
        ReactiveFormsModule,
        MatTooltipModule,
        MatTableModule,
        MatPaginator,
        MatSortModule,
        MatButtonModule,
        TiretPipe
    ],
    providers: [
        {
            provide: MatPaginatorIntl,
            useClass: CustomPaginatorIntlService
        }
    ]
})
export class ContenusEvenementSessionComponent implements OnInit {
  detailSession!: DetailSessionModel;
  evenements: EvenementSessionModel[] = [];
  evenementsAfficher: EvenementSessionModel[] = [];
  evenementsFiltreEncours: EvenementSessionModel[] = [];
  sessionId: number = 0;
  pageIndex: number = 0;
  pageSize: number = 10;
  currentPage: number = 0;
  totalItems: number = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  textFilter: string = '';
  isLoading: boolean = true;
  isFiltering: boolean = false;
  textRechercher: string = "";

  moment = moment;
  dataSource!: MatTableDataSource<EvenementSessionModel>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns: string[] = [
    'id',
    'type',
    'duree',
    'reponse',
    'resultat',
    'dateEvenement'
  ];
  constructor(private changeDetectorRef: ChangeDetectorRef, private contenuSessionService: ContenuSessionService, private route: ActivatedRoute, private location: Location) {
    this.dataSource = new MatTableDataSource<EvenementSessionModel>([]);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.sessionId = Number(this.obtenirEvenementsSession(params['id']));
      if (!isNaN(this.sessionId) && this.sessionId > 0) {
        this.obtenirEvenementsSession(this.sessionId);
      }
    })
  }

  ngAfterViewInit() {
    if (this.sort) {
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      this.totalItems = this.evenements.length;
      this.refreshDataSource();
    }
  }

  paginer(event?: PageEvent) {
    if (event) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    }
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.evenementsAfficher = this.evenementsFiltreEncours.slice(startIndex, endIndex);
    this.dataSource.data = this.evenementsAfficher;
    this.changeDetectorRef.detectChanges();
  }

  sortDataChange(sortState: Sort) {
    if (sortState.direction) {
      this.dataSource.sort = this.sort;
    }
  }

  filtreRecherche(): void {
    if (this.textRechercher && this.textRechercher.length > 2) {
      const textRechercher = this.textRechercher.trim().toLowerCase();
      this.evenementsFiltreEncours = this.evenementsFiltreEncours.filter(event => {
        const checkValue = (value: any): boolean => {
          if (value && typeof value === 'object') {
            return Object.values(value).some(v => checkValue(v));
          }
          return value && String(value).toLowerCase().includes(textRechercher);
        };

        return Object.values(event).some(value => checkValue(value));
      });
    }
  }


  filtre(): void {
    if (this.isFiltering) return;
    this.isFiltering = true;

    try {
      this.applyFilters();

    } finally {
      this.isFiltering = false;
    }
  }

  private applyFilters(): void {
    this.evenementsFiltreEncours = this.evenements;
    this.filtreRecherche();
    this.totalItems = this.evenementsFiltreEncours.length;
    this.paginer();
  }

  reinitialiserFiltre(): void {
    this.textRechercher = "";
    this.applyFilters();
  }
  private updatePaginatorLength(): void {
    if (this.paginator) {
      this.paginator.length = this.evenementsFiltreEncours.length;
      this.totalItems = this.evenementsFiltreEncours.length;
      this.paginator.page.emit();
      this.changeDetectorRef.detectChanges();
    }
  }

  refreshDataSource(): void {
    this.evenementsFiltreEncours = this.evenements;
    this.dataSource = new MatTableDataSource<EvenementSessionModel>(this.evenementsFiltreEncours);
    this.updatePaginatorLength();
  }


  private obtenirEvenementsSession(sessionId: number): void {
    this.isLoading = true;
    this.contenuSessionService.obtenirDetailSession(sessionId).subscribe(detailSession => {
      this.detailSession = detailSession;
      let initialData;
      if(this.detailSession.estEvenementArchive){
         initialData = this.formatInitialData(detailSession.evenementArchives);
      } else {
        initialData = this.formatInitialData(detailSession.evenements);
      }
      const scormEvenement = this.unflattenScormObject(initialData);
      console.log(JSON.stringify(scormEvenement));
      this.evenements = this.mapperTypeEvenement(scormEvenement);
      this.evenementsFiltreEncours = this.evenements;
      this.totalItems = this.evenements.length;
      this.dataSource = new MatTableDataSource<EvenementSessionModel>(this.evenements);
      this.applyFilters();
      this.isLoading = false;
    });
  }

  mapperTypeEvenement(scormEvenement: any): EvenementSessionModel[] {
    let evenements: EvenementSessionModel[] = [];

    if (!scormEvenement || !scormEvenement["cmi"] || !scormEvenement["cmi"]["interactions"]) return evenements;

    for (const key in scormEvenement["cmi"]["interactions"]) {
       let evenement: EvenementSessionModel = new EvenementSessionModel();
       evenement.id = key;
       if(scormEvenement["cmi"]["interactions"][key]["id"]){
          console.log( "id key: " + key + " = " + scormEvenement["cmi"]["interactions"][key]["id"]);
          evenement.type = scormEvenement["cmi"]["interactions"][key]["id"];
       }
       if(scormEvenement["cmi"]["interactions"][key]["result"]){
        console.log( "result key: " + key + " = " + scormEvenement["cmi"]["interactions"][key]["result"]);
        evenement.resultat = scormEvenement["cmi"]["interactions"][key]["result"];
       }
        if(scormEvenement["cmi"]["interactions"][key]["latency"]){
          console.log( "durée key: " + key + " = " + scormEvenement["cmi"]["interactions"][key]["latency"]);
          evenement.duree = scormEvenement["cmi"]["interactions"][key]["latency"];
          evenement.duree = this.fromString(evenement.duree);
       }
        if(scormEvenement["cmi"]["interactions"][key]["timestamp"]){
           console.log( "date evenement key: " + key + " = " + scormEvenement["cmi"]["interactions"][key]["timestamp"]);
           evenement.dateEvenement = scormEvenement["cmi"]["interactions"][key]["timestamp"];
       }
        if(scormEvenement["cmi"]["interactions"][key]["correct_responses"]){
         for (const index in scormEvenement["cmi"]["interactions"][key]["correct_responses"]) {
            console.log( "correct_responses key: " + key + " = " + scormEvenement["cmi"]["interactions"][key]["correct_responses"][index]["pattern"]);
            evenement.reponse = scormEvenement["cmi"]["interactions"][key]["correct_responses"][index]["pattern"];
         }
       }
       evenements.push(evenement);
    }
    return evenements;
  }

 formatInitialData(data: any) {
    const result: any = {};

    for (const item of data) {
      const key = item.typeEvenement;
      const value = item.valeur;

      result[key] = value;
    }

    return result;
 }

 unflattenScormObject(flat: Record<string, any>): any {
  const result: any = {};

  for (const flatKey in flat) {
    const value = flat[flatKey];
    const parts = flatKey.split('.');

    let current = result;

    for (let i = 0; i < parts.length; i++) {
      const key = parts[i];
      const isLast = i === parts.length - 1;

      const arrayIndex = Number(key);
      const isArrayIndex = !isNaN(arrayIndex) && key.trim() !== '';

      if (isLast) {
        if (isArrayIndex && Array.isArray(current)) {
          current[arrayIndex] = value;
        } else {
          current[key] = value;
        }
      } else {
        const nextKey = parts[i + 1];
        const nextIndex = Number(nextKey);
        const nextIsArray = !isNaN(nextIndex);

        if (isArrayIndex) {
          if (!Array.isArray(current)) {
            current = [];
          }
          if (!current[arrayIndex]) {
            current[arrayIndex] = nextIsArray ? [] : {};
          }
          current = current[arrayIndex];
        } else {
          if (!current[key]) {
            current[key] = nextIsArray ? [] : {};
          }
          current = current[key];
        }
      }
    }
   }

   return result;
 }

  fromString(timeSpan: string): string {
  if (!timeSpan || !timeSpan.startsWith("PT")) return "00:00";

  let hours = 0, minutes = 0, seconds = 0;

  const hourMatch = timeSpan.match(/(\d+(?:\.\d+)?)H/);
  const minuteMatch = timeSpan.match(/(\d+(?:\.\d+)?)M/);
  const secondMatch = timeSpan.match(/(\d+(?:\.\d+)?)S/);

  if (hourMatch) hours = parseFloat(hourMatch[1]);
  if (minuteMatch) minutes = parseFloat(minuteMatch[1]);
  if (secondMatch) seconds = parseFloat(secondMatch[1]);

  let totalMinutes = hours * 60 + minutes;

  totalMinutes += Math.floor(seconds / 60);
  seconds = Math.round(seconds % 60);

  return `${totalMinutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

  Retour(): void {
    this.location.back();
  }

}
